import React from 'react';
import { AlertTriangle } from 'lucide-react';
import './commerce.css';

// The apology shown on every page while the shop has paused ordering for the day, with the time it reopens.
export default function PauseBanner({ pause }) {
  if (!pause?.active) return null;
  const until = new Date(pause.until), sameDay = until.toDateString() === new Date().toDateString();
  const when = Number.isNaN(until.getTime()) ? '' : `${sameDay ? 'today' : 'tomorrow'} at ${until.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })}`;
  return <div className="pause-banner" role="status">
    <AlertTriangle aria-hidden="true" />
    <span><b>Sorry, we have reached today's order limit.</b> {when ? `Ordering opens again ${when}.` : 'Ordering opens again soon.'} Your cart is saved, so please come back then. Thank you for your patience.</span>
  </div>;
}
